<script>

//TODO refactor to allow view of detailed inventory by location, also allowing specific product grouping

export default {
  name: "CurrentInventory",
  data: () => {
    return {
      inv: {},
      search: '',
      inventoryLocationDetails: [],
      products: [],
      mapProd: [],
      locations: [],
      mapLocation: [],
    }
  },
  computed: {
    filteredInv() {
      if (!this.search) {
        return this.inv;
      }
      return this.inv.filter(prod => prod.title.toLowerCase().includes(this.search.toLowerCase()));
    },
    groupedInventoryDetails() {
      const filteredInventory = this.search
          ? this.inventoryLocationDetails.filter(loc => this.getProductById(loc.product).title.toLowerCase().includes(this.search.toLowerCase()))
          : this.inventoryLocationDetails;

      return filteredInventory.reduce((r, a) => {
        r[a.inventoryLocation] = [...r[a.inventoryLocation] || [], a];
        return r;
      }, {});
    },
    filteredInventoryLocationDetails() {
      return this.search
          ? this.inventoryLocationDetails.filter(loc => this.getProductById(loc.product).title.toLowerCase().includes(this.search.toLowerCase()))
          : this.inventoryLocationDetails;
    },
  },
  methods: {
    printPage(id) {

      let printContents = document.getElementById(id).innerHTML;

      let currentDateTime = new Date().toLocaleString();

      let printWindow = window.open('', '_blank');
      printWindow.document.write(`
<html>
    <style>
    .grid-container {
        display: grid;
        grid-template-columns: 1fr 1fr; /* this splits your container into two equal width columns */
        grid-gap: 1em; /* this is optional, it sets some space between your columns */
        width: 800px;
        margin-left: auto;
        margin-right: auto;
    }

    .table-container {
        max-height: 500px;
        width: 808px;
        background: rgba(237, 237, 237, 0.68);

        margin: 0 auto 20px auto;
    }

    .table-container table {
        width: 800px;
        border-collapse: collapse;
        margin-left: auto;
        margin-right: auto;
        font-family: 'SDE-Font-Regular', sans-serif;
    }

    .table-container table td {
        padding: 1px;
    }

    .table-container table thead th {
        background-color: #97989AFF;
        color: #f9f9f9;
        font-weight: bold;
        font-size: 15px;
        border: 1px solid #97989AFF;
        border-left: none;
    }

    .table-container table tbody td {
        color: #97989AFF;
        border: 1px solid #97989AFF;
        font-size: 15px;
        text-align: left;
    }

    .table-container table tbody th {
        color: #97989AFF;
        border: 1px solid #97989AFF;
        font-size: 15px;
        border-left: none;
    }

    .table-container table tbody tr {
        background-color: #f9fafb;
    }

    .table-container table tbody tr:nth-child(odd) {
        background-color: #ffffff;
    }

    .table-container table tbody tr:hover td {
        color: white;
    }

    .table-container table tbody tr:hover th {
        color: white;
    }

<!-- TODO remove hovers -->


    .table-container thead tr th {
        position: sticky;
        top: -1px;
        box-shadow: 0px 2px 2px #f0f0f0; /* Adds a shadow */
        z-index: 1;
    }
    </style>
    <head>
        <title>Print</title>
    </head>
    <body>
    <div>
    <label> Fecha: ${currentDateTime}</label>
</div>
        ${printContents}


    </body>
</html>`
      );
      printWindow.document.close();
      printWindow.print();

    },
    async getInvData() {
      try {
        let res = await this.$api.get("/auth/inventory/general");
        if (res.status.toString() === "200") {
          this.inv = res.data
        }
      } catch (error) {
        console.log("can't get inventory data")
      }
    },
    async getInventoryLocationDetail() {
      try {
        let res = await this.$api.get("/auth/inventory/locations/details");
        if (res.status.toString() === "200") {
          this.inventoryLocationDetails = res.data.map(item => ({
            ...item,
            expires: item.expires.substring(0, 10),
          }));
        }
      } catch (error) {
        console.log("can't get inventoryLocationDetails data")
      }
    },
    async getLocation() {
      try {
        let res = await this.$api.get("/auth/inventory/locations");
        if (res.status.toString() === "200") {
          this.locations = res.data
        }
      } catch (error) {
        console.log("can't get location data")
      }
    },
    async getProd() {
      try {
        let res = await this.$api.get("/auth/products");
        if (res.status.toString() === "200") {
          this.products = res.data
        }
      } catch (error) {
        console.log("can't get products data")
      }
    },
    getProductById(id) {
      return this.mapProd[id] || {};
    },
    getLocationById(id) {
      return this.mapLocation[id] || {};
    }
  },
  created() {
    this.getProd().then(() => {
      this.mapProd = this.products.reduce((map, prod) => ({...map, [prod.id]: prod}), {});
    });
    this.getInvData()
    this.getLocation().then(() => {
      this.mapLocation = this.locations.reduce((map, location) => ({...map, [location.id]: location}), {});
    })
    this.getInventoryLocationDetail()
  }
}

</script>

<template>
  <h1>Inventario</h1>

  <form class="Form">
    <input type="text" v-model="search"
           placeholder="Buscar en inventario">
  </form>
  <div id="general-inv">
  <h2>Inventario General</h2>

  <div class="container mt-4 table-container" v-if="filteredInv.length > 0" >
    <table class="table table-bordered">
      <thead>
      <tr>
        <th>#</th>
        <th>Nombre</th>
        <th>Existencia</th>
        <th>Objeto de Gasto</th>
      </tr>

      </thead>
      <tbody>

      <tr v-for="(prod, index) in filteredInv" :key="prod.productId">
        <th scope="row">{{ index + 1 }}</th>
        <td>{{ prod.title }}</td>
        <td>{{ prod.quantity }}</td>
        <td>{{ prod.expenseCode }}</td>
      </tr>

      </tbody>
    </table>
  </div>
    <div v-else>
      <p class="bordered-p">No se encontro coincidencia con su busqueda.</p>
    </div>
  </div>



  <button @click="printPage('general-inv')">Imprimir</button>

  <div v-for="(group, inventoryLocation) in groupedInventoryDetails" :key="inventoryLocation">
    <div :id="`inv-loc-${inventoryLocation}`">
    <h2>Inventario: {{ getLocationById(inventoryLocation).name }}</h2>
    <div class="container mt-4 table-container" >
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>#</th>
          <th>Nombre</th>
          <th>Existencia</th>
          <th>Expira</th>
          <th>Lote</th>
          <th>Codigo de barras</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in group" :key="index">
          <th scope="row">{{ index + 1 }}</th>
          <td>{{ getProductById(item.product).title }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ item.expires.substring(0, 4) === "0000" ? '' : item.expires.substring(0, 10) }}</td>
          <td>{{ item.itemBatch }}</td>
          <td>{{ item.barcode }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    </div>
    <button @click="printPage(`inv-loc-${inventoryLocation}`)">Imprimir</button>
  </div>

  <div id="inv-general">
  <h2>Inventario General Detallado</h2>

  <div class="container mt-4 table-container" v-if="filteredInventoryLocationDetails.length > 0" id="inv-general">
    <table class="table table-bordered">
      <thead>
      <tr>
        <th>#</th>
        <th>Nombre</th>
        <th>Almacen</th>
        <th>Existencia</th>
        <th>Expira</th>
        <th>Lote</th>
        <th>Codigo de barras</th>
      </tr>

      </thead>
      <tbody>

      <tr v-for="(prod, index) in filteredInventoryLocationDetails" :key="index">
        <th scope="row">{{ index + 1 }}</th>
        <td>{{ getProductById(prod.product).title }}</td>
        <td>{{ getLocationById(prod.inventoryLocation).name }}</td>
        <td>{{ prod.quantity }}</td>
        <td>{{ prod.expires.substring(0, 4) === "0000" ? '' : prod.expires.substring(0, 10) }}</td>
        <td>{{ prod.itemBatch }}</td>
        <td>{{ prod.barcode }}</td>
      </tr>

      </tbody>
    </table>
  </div>

  <div v-else>
    <p class="bordered-p">No se encontro coincidencia con su busqueda.</p>
  </div>

    </div>

  <button @click="printPage('inv-general')">Imprimir</button>



</template>

<style>


</style>